/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbRespAppliedFilters_viewer$ref = any;
export type SbRespAppliedFilters_viewer = {
    readonly isSbSharedRefineMenuSearchWithinEnabled: boolean | null;
    readonly " $refType": SbRespAppliedFilters_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespAppliedFilters_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isSbSharedRefineMenuSearchWithinEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "NON_MVP_SEARCH_BROWSE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
        }
    ]
} as any);
(node as any).hash = '70924dcc8b3642193b05af64f4d73c89';
export default node;
